import React from 'react';
import {Alert, Badge, Form, Icon, Input, Button, Select, DatePicker, Row, Col, Radio, Slider, Checkbox } from 'antd';
import get from 'lodash/get';
import { connect } from 'react-redux';

import { updateUserRequest, createUserRequest } from "../../api/requests";
import {
  getUserCreatePermission,
  getUserUpdatePermission
} from "../../reducers/user/selectors";

import classes from './SettingsUserForm.css';
import { logout } from "../../reducers/user/actions";

const { Option } = Select;

const timeZones = {
  '': null,
  'America/Edmonton': 'MT',
  'America/Vancouver': 'PT',
  'America/Winnipeg': 'CT',
  'America/Toronto': 'ET',
  'America/Halifax': 'AT',
};

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class SettingsUserForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
    };
  }

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const user = {...values};
          let userCreated;

          user.short_tz = timeZones[user.time_zone];
          if (user.time_zone === "") {
            user.time_zone = null;
          }

          if (this.props.id) {
            await updateUserRequest(this.props.id , user);
          } else {
            const { data } = await createUserRequest(user);
            userCreated = data;
          }

          this.setState({ isLoading: false, requestResult: { type: 'success', message: 'Success' } });

          setTimeout(() => {
            this.props.onSubmit(this.props.id, userCreated);
          }, 1000);
        } catch (e) {
          if (get(e, 'response.status') === 401) { this.props.logout();  return; }
          this.setState({ isLoading: false, requestResult: { type: 'error', message: get(e, 'response.data.message', 'Error') } });

          if (get(e, 'response.data.errors')) {
            const errors = {};
            Object.keys(get(e, 'response.data.errors')).forEach(errorFieldKey => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(errorMessage => new Error(errorMessage))
              }
            });
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };


  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { userUpdatePermission, userCreatePermission, id, isNew } = this.props;

    const isEditable = id ? userUpdatePermission : userCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className='headline-default'>
            {this.props.id ? (<span>{this.props.username} <Badge count='Edit' style={{ backgroundColor: '#2968AE' }} /></span>) : isNew ? 'Add user' : ''}
          </h4>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Username:</b>
                <Form.Item>
                  {getFieldDecorator('username', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'username', '')
                  })(
                    <Input disabled={!isEditable} placeholder='User name' />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>First name:</b>
                <Form.Item>
                  {getFieldDecorator('first_name', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'first_name', '')
                  })(
                    <Input disabled={!isEditable} />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>Last name:</b>
                <Form.Item>
                  {getFieldDecorator('last_name', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'last_name', '')
                  })(
                    <Input disabled={!isEditable} />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={24}>
              <Alert message='Changing First and Last name will modify the randomization ID' type="warning" style={{ margin: '-15px 0 10px' }} />
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Email:</b>
                <Form.Item>
                  {getFieldDecorator('email', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'email', '')
                  })(
                    <Input disabled={!isEditable} />
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>Phone number:</b>
                <Form.Item>
                  {getFieldDecorator('phone_number', {
                    initialValue: get(this.props, 'phone_number', '')
                  })(
                    <Input disabled={!isEditable} />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Time Zone:</b>
                <Form.Item>
                  {getFieldDecorator('time_zone', {
                    initialValue: get(this.props, 'time_zone', '')
                  })(
                    <Select placeholder='Select'>
                      <Option value="">None</Option>
                      <Option value="America/Edmonton">America/Edmonton</Option>
                      <Option value="America/Vancouver">America/Vancouver</Option>
                      <Option value="America/Winnipeg">America/Winnipeg</Option>
                      <Option value="America/Toronto">America/Toronto</Option>
                      <Option value="America/Halifax">America/Halifax</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col span={12}>
              <label>
                <b>Short TZ</b>
                <Form.Item>
                  {getFieldDecorator('short_tz', {
                    initialValue: timeZones[getFieldValue('time_zone')]
                  })( <Input disabled={true} type='text' /> )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            {isNew && <Col span={24}>
              <label>
                {getFieldDecorator('send_password_creation_link', {
                  initialValue: get(this.props, 'send_password_creation_link', false),
                  valuePropName: 'checked'
                })(
                  <Checkbox disabled={!isEditable}>Send password creation link</Checkbox>
                )}
              </label>
              <br/>
              <br/>
            </Col>}
            {isNew && <Col span={24}>
              <label>
                {getFieldDecorator('sending_notifications', {
                  initialValue: get(this.props, 'sending_notifications', false),
                  valuePropName: 'checked'
                })(
                  <Checkbox disabled={!isEditable}>Do not send out welcome and password creation e-mails?</Checkbox>
                )}
              </label>
              <br/>
              <br/>
            </Col>}
            <Col span={24}>
              <label>
                {getFieldDecorator('is_2fa_enabled', {
                  initialValue: get(this.props, 'is_2fa_enabled', false),
                  valuePropName: 'checked'
                })(
                  <Checkbox disabled={!isEditable}>Is 2fa enabled?</Checkbox>
                )}
              </label>

              <div className={classes.wrapper2faOptions}>
                <label>
                  {getFieldDecorator('is_2fa_email_enabled', {
                    initialValue: get(this.props, 'is_2fa_email_enabled', false),
                    valuePropName: 'checked'
                  })(
                    <Checkbox disabled={!isEditable}>Email 2fa</Checkbox>
                  )}
                </label>
                <label>
                  {getFieldDecorator('is_2fa_mobile_app_enabled', {
                    initialValue: get(this.props, 'is_2fa_mobile_app_enabled', false),
                    valuePropName: 'checked'
                  })(
                    <Checkbox disabled={!isEditable}>Mobile app 2fa</Checkbox>
                  )}
                </label>
                <label>
                  {getFieldDecorator('is_2fa_sms_enabled', {
                    initialValue: get(this.props, 'is_2fa_sms_enabled', false),
                    valuePropName: 'checked'
                  })(
                    <Checkbox disabled={!isEditable}>SMS 2fa</Checkbox>
                  )}
                </label>
              </div>
            </Col>
          </Row>

          <Row gutter={12}>
            {!(getFieldValue('send_password_creation_link') && isNew) && <Col span={12}>
              <label>
                <b>Set new password {id && '(optional)'}</b>
                <Form.Item>
                  {getFieldDecorator('password', {
                    rules: [
                      { required: !id && true, message: 'Required' },
                    ]
                  })(
                    <Input type='password' disabled={!isEditable} />
                  )}
                </Form.Item>
              </label>
            </Col>}
            {get(this.props, 'user_id', '') && <Col span={12}>
              <label>
                <b>Randomization Platform - User ID</b>
                <Form.Item>
                  {getFieldDecorator('user_id', {
                    initialValue: get(this.props, 'user_id', ''),
                    rules: [{ required: id && true, message: 'Required' }]
                  })(
                    <Input disabled={true} />
                  )}
                </Form.Item>
              </label>
            </Col>}
          </Row>

          {requestResult.type && (<Alert message={requestResult.message} type={requestResult.type} className={classes.submitResult} />)}

          <div className={classes.actionWrapper}>
            {isEditable && (<Form.Item>
              <Button type="primary" size="large" htmlType="submit" className={classes.submitButton}>
                Save
                {isLoading && <Icon type="loading" />}
              </Button>&nbsp; &nbsp;
            </Form.Item>)}

            <Button type="default" size="large" htmlType="button" className={classes.submitButton} onClick={this.props.onCancel}>
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  userCreatePermission: getUserCreatePermission(state),
  userUpdatePermission: getUserUpdatePermission(state)
});

const mapDispatchToProps = { logout };

export default Form.create({ name: 'user' })(connect(mapStateToProps, mapDispatchToProps)(SettingsUserForm));



// WEBPACK FOOTER //
// ./src/components/SettingsUserForm/SettingsUserForm.js